<template>
  <div class="subgroup__image__container w-[507px]" style="height: fit-content;">
    <!-- <img :src="imageThumbnail" class="w-auto max-w-[500px] min-w-full h-auto" /> -->
    <img v-if="!originalImageLoaded" class="w-auto max-w-[500px] min-w-full h-auto" :src="imageThumbnail" />
    <img v-show="originalImageLoaded" class="w-auto max-w-[500px] min-w-full h-auto" :src="fileUrl"
      @load="onOriginalImageLoad" />
  </div>
</template>

<script>
export default {
  name: 'NftImage',
  props: {
    fileUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    imageThumbnail() {
      const url = this.fileUrl;
      if (!url) return '';

      const extensionIndex = url.lastIndexOf('.');
      if (extensionIndex === -1) return url; // No extension found

      const extension = url.substring(extensionIndex);
      const baseUrl = url.substring(0, extensionIndex);
      return `${baseUrl}_thumb${extension}`;
    },
  },
  data() {
    return {
      originalImageLoaded: false,
    };
  },
  methods: {
    onOriginalImageLoad() {
      this.originalImageLoaded = true;
    },
  },
};
</script>

<style scoped>
@media (max-width: 725px) {
  .subgroup__image__container img {
    max-width: 100%;
    height: auto;
  }
}
</style>
